import * as Yup from 'yup'

import { persianTranslationRequired } from '../../../helpers/persianNameValidation'
import { entityCodeRegex } from '../../../helpers/regex'

export const roomtypeFormValidationSchema = Yup.object({
  basicDetails: Yup.object({
    name: Yup.string()
      .min(2, 'Enter a name more than 1 characters long')
      .required('This field is required'),
    nameTranslatedList: persianTranslationRequired(),
    code: Yup.string()
      .matches(entityCodeRegex, 'Only letters, numbers, - and _ are allowed')
      .required('This field is required'),
    type: Yup.string().required('This field is required')
  }),
  inventoryAndBooking: Yup.object({
    numberOfRooms: Yup.number()
      .typeError('Enter a number')
      .min(1, 'Enter a number greater than or equal to 1'),
    defaultOccupancy: Yup.number()
      .typeError('Enter a number')
      .min(1, 'Enter a number greater than or equal to 1'),
    maxOccupancy: Yup.number()
      .typeError('Enter a number')
      .min(1, 'Enter a number greater than or equal to 1')
  }),
  virtualRoomDetails: Yup.object({
    parentRoomTypeCode: Yup.string().when('basicDetails.type', {
      is: 'Virtual',
      then: Yup.string().required('This field is required')
    }),
    virtualRoomAvailabilityMultiplier: Yup.number().when('basicDetails.type', {
      is: 'Virtual',
      then: Yup.number()
        .typeError('Enter a number')
        .min(0, 'Enter a number greater than or equal to 0')
        .required('This field is required')
    })
  }).nullable()
})
